import { NgForOf, NgIf } from '@angular/common';
import { Component, effect, signal, Signal } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { QBreadcrumbsService, TQBreadCrumbs } from './breadcrumbs.service';
import { IconComponent } from '@app/shared/components/icon/icon.component';
import { RouterLink } from '@angular/router';

@Component({
    selector: 'q-breadcrumbs',
    templateUrl: './breadcrumbs.component.html',
    styleUrls: ['./breadcrumbs.component.scss'],
    standalone: true,
    imports: [TranslateModule, NgForOf, NgIf, IconComponent, RouterLink]
})
export class QBreadcrumbsComponent {
    breadcrumbs: Signal<TQBreadCrumbs> = signal([]);

    constructor(private qBreadcrumbsService: QBreadcrumbsService) {
        this.breadcrumbs = this.qBreadcrumbsService.breadCrumbs;
    }
    ngOnInit() {

    }
}
